import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'historico-usuario-delegacao',
      component: LayoutPadrao,
      children: [
         {
            path: '/historico-usuario-delegacao',
            name: 'historico-usuario-delegacao',
            component: () => import('../pages/usuario-delegacao-hist.vue')
         }
      ]
   }
]
